import Arrow from "../Arrow";

export default function PrevArrow(props) {
  const { onClick, style, currentSlide } = props;
  return (
    <div
      onClick={onClick}
      className={`slick-prev slick-arrow ${
        currentSlide === 0 ? " slick-disabled" : ""
      }`}
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      style={{ ...style }}
    >
      <Arrow color={"#fff"} style={{ rotate: "-90deg" }} />
    </div>
  );
}
